import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllWillWritingAdvicesCommand } from '@/app/will_writing_advice/commands/get-all-will-writing-advices.command';

const httpClient = new AxiosClient()

export const getAllWillWritingAdvicesCommand = new GetAllWillWritingAdvicesCommand(httpClient, store)
